import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { MonthlyReportDetailTemplate } from 'components/Templates'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { parseToDate } from 'lib/helper'
import format from 'date-fns/format'

const MonthlyReportDetail: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const isValidPath = /\/account\/revenue\/monthly_report\/.+/.test(pathname)
  const yearMonth = isValidPath ? pathname.split('/account/revenue/monthly_report/')[1] : undefined
  const datetime = yearMonth ? parseToDate(yearMonth + '01') : new Date()
  const headline = `${format(datetime, 'yyyy年M月')}売上レポート`
  return (
    <Layout headline={'月次レポート'} iconPath={'/icon/white/revenue.svg'} title={'月次レポート'}>
      <MonthlyReportDetailTemplate headline={headline} datetime={datetime} yearMonth={yearMonth} />
    </Layout>
  )
}

export default MonthlyReportDetail
